import React, { useEffect, useRef, useState } from "react";
import styles from "../central.module.css";
import { useRouter } from "next/router";
import { Button, Link } from "@mui/material";
import Head from "next/head";
import MembershipModal from "../../../components/Modal/MembershipModal";
import BlockData from "../../../central-doctraine-json/chapter3.json";
import Common_html from "./Common_html";

export default function Chapter_3() {
  const router = useRouter();
  const location = useRouter();

  const [membershipOpen, setMembershipOpen] = useState(false);
  const memberfunc = () => {
    setMembershipOpen(true);
  };

  // const corosalref = useRef()

  // useEffect(() => {
  //   if (corosalref.current) {
  //     corosalref.current.scrollIntoView({
  //       behavior: "smooth",
  //       block: "nearest",
  //       inline: "start"
  //     })
  //   }
  //   console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])

  return (
    <>
      <Head>
        <title>Opportunities, structure and plans | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Divine Infinite Being, Central Doctrine, Chapter-III"
        ></meta>
        <meta
          property="og:title"
          content="Opportunities, structure and plans | School of Our Divine Infinite Being"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Chapter3_OG_image_Mithun_04-10-2023_v1_new.webp"
        ></meta>
        <meta property="og:image:alt" content="Image of a celestial blueprint, featuring interconnected pathways and glowing orbs, symbolizing opportunities and the structured plan of the Divine Infinite Being. The design is intricate, with layers representing different levels of spiritual growth and alignment with a higher purpose."></meta>
        <meta
          property="og:description"
          content="Our school consists of an inner Mystery School as well as formal certification in Tarot divination and Astrology with an emphasis in archētypal Astrology."
        ></meta>
        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=3"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Chapter3_OG_image_Mithun_04-10-2023_v1_new.webp"></meta>
        <meta property="twitter:image:alt" content="Image of a celestial blueprint, featuring interconnected pathways and glowing orbs, symbolizing opportunities and the structured plan of the Divine Infinite Being. The design is intricate, with layers representing different levels of spiritual growth and alignment with a higher purpose."></meta>
        <meta name="twitter:url" content="https://www.divineinfinitebeing.com/central-doctrine?chapter=3"></meta>
        <meta name="twitter:title" content="Opportunities, structure and plans | School of Our Divine Infinite Being"></meta>
        <meta name="twitter:description" content="Our school consists of an inner Mystery School as well as formal certification in Tarot divination and Astrology with an emphasis in archētypal Astrology."></meta>
         <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=3" />
      </Head>


       <Common_html BlockData={BlockData} />

      <MembershipModal
        membershipOpen={membershipOpen}
        setMembershipOpen={setMembershipOpen}
      />
    </>
  );
}
